import { NavLink } from 'react-router-dom';
import { cx } from '@/components/ui';

/**
 * 계좌 영역 안의 하위 탭. (2026-08-28)
 *
 * 🔴 TradingNav 와 나눈 이유 — 권한이 다르다
 *   TradingNav 의 화면들은 스크리너가 만든 공용 결과라 가족 모두가 본다(TRADING).
 *   여기 둘은 사용자 본인의 실제 자산과 체결이다(TRADING_ACCOUNT).
 *   같은 줄에 섞어 놓으면 동생 화면에 눌러도 안 열리는 탭이 남는다 —
 *   화면이 거짓말을 하는 상태다.
 *
 * 매매일지가 이쪽으로 온 경위
 *   처음에는 TradingNav 에 있었다. "토스 계정이 하나뿐" 이라는 이유였는데
 *   그것은 누가 볼 수 있는가에 대한 답이 아니었다. 가족이 로그인하면
 *   형의 실제 체결·평단·손익이 그대로 보인다. (MyTradeController 주석)
 */

const TABS = [
  { to: '/trading/account', label: '계좌·보유·체결', end: true },
  { to: '/trading/account/my-trades', label: '매매일지', end: false },
  // 🔴 자동매매는 내 실계좌를 움직이는 설정이라 여기(TRADING_ACCOUNT) 에 둔다.
  //   관리자 탭에 두면 "관리자 = 남의 매매도 만질 수 있는 자리" 처럼 섞인다 (119번 5-3절)
  { to: '/trading/account/autotrade', label: '자동매매', end: false },
];

export function AccountNav() {
  return (
    <nav className="flex flex-wrap gap-1" aria-label="계좌 화면">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          /*
            end 가 필요한 이유
              /trading/account 는 매매일지 경로의 접두사다. end 가 없으면
              매매일지 화면에서도 '계좌·보유·체결' 이 활성으로 남는다.
          */
          end={tab.end}
          className={({ isActive }) =>
            cx(
              'rounded-full px-3 py-1 text-sm transition-colors',
              isActive
                ? 'bg-brand text-brand-fg'
                : 'bg-surface-hover text-fg-muted hover:text-fg',
            )
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </nav>
  );
}
